module.exports = __webpack_public_path__ + "static/media/charge-icon.f403d655.svg";